import styled from 'styled-components';

const SelectLabel = styled.label.attrs({
  className: 'mb-1',
})`
  font-size: 16px;
  font-weight: 400;
  color: #374151;
`;

export { SelectLabel };
